import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { PosCaptchaModule } from 'src/app/shared/pos-captcha/pos-captcha.module';
import { ChangePasswordComponent } from './change-password.component';



@NgModule({
  declarations: [ChangePasswordComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PosCaptchaModule
  ],
  providers: [ToastrModule],
  exports: [ChangePasswordComponent]
})
export class ChangePasswordModule { }
